import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import styles from '../../../styles/components/layout/HeaderSection.module.css';
import HeaderBrand from './HeaderBrand';
import HeaderContact from './HeaderContact';

/**
 * Desktop Header Component
 * Displays header content optimized for desktop screens
 * 
 * @param {Object} data - Header data object
 * @param {String} logoUrl - Logo image URL
 * @param {String} alternativeText - Logo alt text
 * @param {Array} menu - Menu items array
 * @param {Boolean} isMenuVisible - Whether menu should be visible
 * @param {Boolean} isMenuOpen - Whether mobile menu is open
 * @param {Boolean} isBookingInformation - Whether this is booking information page
 * @param {Object} navbarStyle - Navbar style object
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {String} className - Additional CSS classes
 */
const DesktopHeader = ({ 
    data, 
    logoUrl, 
    alternativeText, 
    menu, 
    isMenuVisible, 
    isMenuOpen, 
    setIsMenuOpen,
    isBookingInformation, 
    navbarStyle, 
    isDarkMode, 
    className = '' 
}) => {
    const router = useRouter();

    // Function to check if menu item is active
    const isMenuItemActive = menuUrl => {
        const currentPath = router.asPath;
        if (currentPath === menuUrl) return true;
        if (menuUrl === '/' && currentPath === '/') return true;
        return menuUrl !== '/' && currentPath.startsWith(menuUrl);
    };
    return (
        <nav
            id="navigation"
            className={`${styles.navbar} navbar navbar-expand-lg ${!isBookingInformation ? 'fixed-top' : ''} ${
                isDarkMode ? styles['dark-navbar'] : ''
            } ${className}`}
            style={navbarStyle}
            role="navigation"
            aria-label="Main navigation"
        >
            <div className="tw-container color-white py-2 position-relative d-flex align-items-center justify-content-between w-100">
                <HeaderBrand 
                    logoUrl={logoUrl}
                    alternativeText={alternativeText}
                    isMobile={false}
                />

                {isMenuVisible && (
                    <nav
                        className={`ml-16 d-flex align-items-center ${styles['navbar-collapse']} ${isMenuOpen ? `${styles['navbar-drop']}` : ''}`}
                        id="navbarSupportedContent"
                    >
                        <ul className="navbar-nav d-flex flex-row align-items-center mb-0 ml-4">
                            {menu.map((item, index) => {
                                if (!item.isHidden) {
                                    const isActive = isMenuItemActive(item.url);
                                    return (
                                        <li className="nav-item ms-2 d-flex align-items-center" key={index}>
                                            <Link
                                                href={item.url}
                                                className={`nav-link ${styles['menu-links']} ${isActive ? styles.isActive : ''}`}
                                                onClick={() => setIsMenuOpen(false)}>
                                                {item.name}
                                            </Link>
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                        <HeaderContact 
                            contact={data.Contact}
                            isMobile={false}
                        />
                    </nav>
                )}
            </div>
        </nav>
    );
};

export default DesktopHeader;
